export default __webpack_public_path__ + "static/media/tr.a1a28a5e.svg";